import { type FridgeType, FRIDGE_TYPES } from '@gozoki/api-types'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const zFridgeForm = z.object({
  description: z
    .string()
    .max(500, {
      message: 'La description doit comporter au maximum 500 caractères.',
    })
    .optional(),
  label: z
    .string()
    .nonempty({ message: 'Le libellé est requis.' })
    .max(100, { message: 'Le libellé doit comporter au maximum 100 caractères.' }),
  reference: z.string().nonempty({ message: 'La référence est requise.' }).max(50, {
    message: 'La référence doit comporter au maximum 50 caractères.',
  }),
  storeReference: z.string().nonempty({ message: 'La référence du magasin est requise.' }).max(50, {
    message: 'La référence du magasin doit comporter au maximum 50 caractères.',
  }),
  type: z.enum([FRIDGE_TYPES.FRIDGE, FRIDGE_TYPES.COLD_ROOM] as [FridgeType, FridgeType]),
})

export type FridgeForm = z.infer<typeof zFridgeForm>

// Form hook
export const useFridgeForm = (defaultValues?: Partial<FridgeForm>) => {
  const form = useForm<FridgeForm>({
    // Validation function
    defaultValues: {
      reference: '',
      label: '',
      description: '',
      type: FRIDGE_TYPES.FRIDGE,
      storeReference: '',
      ...defaultValues,
    },
    resolver: zodResolver(zFridgeForm),
  })

  return form
}
